export default {
  data() {
    return {
      mailTechnicalKeyConst: [
        {label: this.$t('mail_template.technical_key.AccessAutonomousOwner'), value: 'AccessAutonomousOwner'},
        {
          label: this.$t('mail_template.technical_key.AccessAutonomousOwner_commerciale'),
          value: 'AccessAutonomousOwner_commerciale',
        },
        {
          label: this.$t('mail_template.technical_key.AccessPasswordForgotEmployee'),
          value: 'AccessPasswordForgotEmployee',
        },
        {label: this.$t('mail_template.technical_key.AccessPasswordForgotOwner'), value: 'AccessPasswordForgotOwner'},
        {label: this.$t('mail_template.technical_key.CRGFirst'), value: 'CRGFirst'},
        {label: this.$t('mail_template.technical_key.CRGHost'), value: 'CRGHost'},
        {label: this.$t('mail_template.technical_key.MandatAvenantSigned_hote'), value: 'MandatAvenantSigned_hote'},
        {label: this.$t('mail_template.technical_key.MandatAvenantSigned_owner'), value: 'MandatAvenantSigned_owner'},
        {label: this.$t('mail_template.technical_key.MandatAvenantToSign'), value: 'MandatAvenantToSign'},
        {label: this.$t('mail_template.technical_key.MandatResiliationCheckList'), value: 'MandatResiliationCheckList'},
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDeclared_concierge'),
          value: 'MandatResiliationDeclared_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDeclared_distribution'),
          value: 'MandatResiliationDeclared_distribution',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDeclared_hote'),
          value: 'MandatResiliationDeclared_hote',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDeclared_owner'),
          value: 'MandatResiliationDeclared_owner',
        },
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDone_distribution'),
          value: 'MandatResiliationDone_distribution',
        },
        {label: this.$t('mail_template.technical_key.MandatResiliationDone_hote'), value: 'MandatResiliationDone_hote'},
        {
          label: this.$t('mail_template.technical_key.MandatResiliationDone_owner'),
          value: 'MandatResiliationDone_owner',
        },
        {label: this.$t('mail_template.technical_key.OnboardingCreated_hote'), value: 'OnboardingCreated_hote'},
        {label: this.$t('mail_template.technical_key.OnboardingStep1Validated'), value: 'OnboardingStep1Validated'},
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_concierge'),
          value: 'OnboardingStep2Updated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_confort'),
          value: 'OnboardingStep2Updated_confort',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_essentielle'),
          value: 'OnboardingStep2Updated_essentielle',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_hote'),
          value: 'OnboardingStep2Updated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Updated_premium'),
          value: 'OnboardingStep2Updated_premium',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_commerciale'),
          value: 'OnboardingStep2Validated_commerciale',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_concierge'),
          value: 'OnboardingStep2Validated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_confort'),
          value: 'OnboardingStep2Validated_confort',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_essentielle'),
          value: 'OnboardingStep2Validated_essentielle',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_hote'),
          value: 'OnboardingStep2Validated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep2Validated_premium'),
          value: 'OnboardingStep2Validated_premium',
        },
        {label: this.$t('mail_template.technical_key.OnboardingStep3Validated'), value: 'OnboardingStep3Validated'},
        {
          label: this.$t('mail_template.technical_key.OnboardingStep3Validated_hote'),
          value: 'OnboardingStep3Validated_hote',
        },
        {label: this.$t('mail_template.technical_key.OnboardingStep4Validated'), value: 'OnboardingStep4Validated'},
        {
          label: this.$t('mail_template.technical_key.OnboardingStep4Validated_concierge'),
          value: 'OnboardingStep4Validated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep4Validated_hote'),
          value: 'OnboardingStep4Validated_hote',
        },
        {label: this.$t('mail_template.technical_key.OnboardingStep5DocsRefused'), value: 'OnboardingStep5DocsRefused'},
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5DocsValidated'),
          value: 'OnboardingStep5DocsValidated',
        },
        {label: this.$t('mail_template.technical_key.OnboardingStep5Validated'), value: 'OnboardingStep5Validated'},
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_commerciale'),
          value: 'OnboardingStep5Validated_commerciale',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_confort_premium_hote'),
          value: 'OnboardingStep5Validated_confort_premium_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_essentielle_hote'),
          value: 'OnboardingStep5Validated_essentielle_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep5Validated_conciergerie'),
          value: 'OnboardingStep5Validated_conciergerie',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_communication'),
          value: 'OnboardingStep6Published_communication',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_hote'),
          value: 'OnboardingStep6Published_hote',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_owner'),
          value: 'OnboardingStep6Published_owner',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_voyageur'),
          value: 'OnboardingStep6Published_voyageur',
        },
        {
          label: this.$t('mail_template.technical_key.OnboardingStep6Published_distribution'),
          value: 'OnboardingStep6Published_distribution',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCanceled_concierge'),
          value: 'ReservationGuestCanceled_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCanceled_hote'),
          value: 'ReservationGuestCanceled_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCanceled_owner'),
          value: 'ReservationGuestCanceled_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCreated_concierge'),
          value: 'ReservationGuestCreated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCreated_hote'),
          value: 'ReservationGuestCreated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestCreated_owner'),
          value: 'ReservationGuestCreated_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestUpdated_concierge'),
          value: 'ReservationGuestUpdated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestUpdated_hote'),
          value: 'ReservationGuestUpdated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationGuestUpdated_owner'),
          value: 'ReservationGuestUpdated_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCanceled_concierge'),
          value: 'ReservationHostCanceled_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCanceled_hote'),
          value: 'ReservationHostCanceled_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCanceled_owner'),
          value: 'ReservationHostCanceled_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCreated_concierge'),
          value: 'ReservationHostCreated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCreated_hote'),
          value: 'ReservationHostCreated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostCreated_owner'),
          value: 'ReservationHostCreated_owner',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostUpdated_concierge'),
          value: 'ReservationHostUpdated_concierge',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostUpdated_hote'),
          value: 'ReservationHostUpdated_hote',
        },
        {
          label: this.$t('mail_template.technical_key.ReservationHostUpdated_owner'),
          value: 'ReservationHostUpdated_owner',
        },
      ],
    };
  },
  methods: {
    displayForMailTechnicalKeyConst(value, returnLabel = '') {
      let result = this.mailTechnicalKeyConst.find((el) => el.value === value);
      return result ? result.label : returnLabel;
    },
  },
};
